import React from 'react'
import { Navigate, RouterProvider , createBrowserRouter} from 'react-router-dom'
import PrivacyPolicy from './PrivacyPolicy'

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <PrivacyPolicy />
    },
    {
      path: "*",
      element: <Navigate to='/' />
    }
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default App